import { FC, SuspenseProps, Suspense as RealSuspensed } from 'react';

import { isSSR } from 'shared/services/helper';

export const Suspensed: FC<SuspenseProps> = (props) => {
  return isSSR() ? <div>{props.fallback ?? props.children}</div> : <RealSuspensed {...props} />;
};
